import {useEffect, useState, useContext } from 'react'
import { useMsal,AuthenticatedTemplate, UnauthenticatedTemplate,  } from '@azure/msal-react'
import { PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import { useForm } from 'react-hook-form'
import ReCAPTCHA from "react-google-recaptcha";
import { Alerts } from '../components/common/Alerts'
import axios from 'axios'
import logo from '../logos/ai-nesting-studio.svg';
import { useCookies } from 'react-cookie';
 
import {
  loadingContext,
  urlValue,
  validContext,
  encrypter,
  openAlert,
  useTranslate
} from '../lib'

import '../styles/login.scss'
import Cookies from 'universal-cookie';
export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const [loading, setLoading] = useContext(loadingContext)
  const [isValid, setIsValid] = useContext(validContext)
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [disableSubmit, setEnableSubmit] = useState(1);  // If you going to use the ReCatpcha, you must useState with value = 0
  const [cookies, setCookie] = useCookies(['prueba5']);
  const { t } = useTranslate();
  const setUserCookies = async (id) =>{

    try {
      const rest = await axios.post(`${urlValue}/setcookies/hashUser`,{value: id}, {withCredentials: true, });
    }catch(error){

    }
  }
  const { instance,accounts  } = useMsal()


  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const e = await instance.handleRedirectPromise();
        if (e) {


          const userEmail = e.account.username
          const ccmsId = userEmail.slice(0, userEmail.indexOf('@'))
          const expire = new Date(e.expiresOn).getTime()
           const azureToken = e.accessToken;
         
          const data = JSON.stringify({
            ccms_name: ccmsId,
            expired_on: expire,
          })
          const encry = encrypter(data, 'IANestingKey')
  
          const config = {
            method: 'post',
            url: `${urlValue}/authorize`,
            headers: {
              Authorization: `bearer ${azureToken}`,
              'Content-Type': 'application/json',
            },
             data: {"usuario": encry},
          }
          axios(config)
            .then(e => {
              getUserInfo({ id: ccmsId, token: e.data.token })
            })
            .catch(error => {
              if (error.response?.status == 403 || error.response?.status == 404) {
                openAlert('#alert-ac', () => { setAlert({ title: error.response.data.message, visible: true }) }, 5000, () => { setAlert({ ...alert, visible: false }) });
              }
              console.error("error0", error)
            })
        }
      } catch (error) {
        console.error('Error en el manejo de redireccionamiento:', error);
      }
    };

    handleRedirect();
  }, []);
  const getUserInfo = async userInfo => {
    try {
      setLoading(true)
      const csrfResp = await axios.get(`${urlValue}/csrf-token`, { withCredentials: true })
      userInfo.csrfToken = csrfResp?.data?.csrfToken
    } catch (err) {
      console.error('Error fetching CSRF token', err)
      setLoading(false)
      return
    }

    try {
      const response = await axios.get(`${urlValue}/studio/user/${userInfo.id}`, {
        headers: {
          'access-token': userInfo.token,
        },
      })

      const hashUser = encrypter(userInfo, 'IANestingKey')
      const hashInfo = encrypter(response.data.user, 'IANestingKey')

      localStorage.setItem('hashUser', hashUser)
      localStorage.setItem('hashInfo', hashInfo)

      // setUserCookies(response.data.user.id)

      setIsValid(true)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching user info', error)
      setLoading(false)
    }
  }
  const handleLogin = (event) => {
    
    const request = {
      scopes: ['user.read', 'openid', 'profile'], // Lista de ámbitos que tu aplicación necesita
    };
 
    
    //setLoading(true)
    instance
      .loginRedirect(request) 
      .then(e => {
        const userEmail = e.account.username
        const ccmsId = userEmail.slice(0, userEmail.indexOf('@'))
        const expire = new Date(e.expiresOn).getTime()
         const azureToken = e.accessToken;
       
        const data = JSON.stringify({
          ccms_name: ccmsId,
          expired_on: expire,
        })
        const encry = encrypter(data, 'IANestingKey')

        const config = {
          method: 'post',
          url: `${urlValue}/authorize`,
          headers: {
            Authorization: `bearer ${azureToken}`,
            'Content-Type': 'application/json',
          },
           data: {"usuario": encry},
        }
        axios(config)
          .then(e => {
            getUserInfo({ id: ccmsId, token: e.data.token })
          })
          .catch(error => {
            console.error("error", error)
          })
      })
      .catch(e => {
        setLoading(false)
        console.error("error en el popup ",e)
        console.error(e)
      })
  }

  return (

    <div className="container-login">

      <img src={logo} alt={t('login.loginApplication')} style={{maxWidth: 300}} />
    
      <button type="button" onClick={handleLogin} className={'loginButton'} disabled={!disableSubmit}>
        {t('login.loginButton')}
      </button> 
  

      <div className="logos">
        <img src="/Teleperformance.svg" alt="Teleperformance" />
      </div>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
    </div>
  )
}

const styles = {
  recaptcha: {
    marginTop: 20,
  }
}